/* eslint-disable import/prefer-default-export */
import { get } from './http';

// mapboxgl token
export function mapToken(context) {
  return get(context, '/map/token');
}
